module.exports = __webpack_public_path__ + "img/T006_Shopping.2d853f09.png";